import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import { dictionaries } from './utils/dictionaries'
import { decodeFromDictionary, formatScore, getRiskLevel } from './types'

interface BbgdexRiskBlackInfoOverviewProps {
  data: any
}

export default function BbgdexRiskBlackInfoOverview({ data }: BbgdexRiskBlackInfoOverviewProps) {
  const theme = useTheme()

  const creditScore = Number(data?.xyp_cpl0081)
  const formattedScore = formatScore(creditScore)
  const riskLevel = getRiskLevel(creditScore)

  const loanInstitutions = decodeFromDictionary(dictionaries, 'xyp_cpl0001', data?.xyp_cpl0001)

  const hasOverdue = data?.xyp_cpl0044 === '1'

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            风险信息概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总信用风险评分、贷款机构及逾期状况,供风险评估参考。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="信用风险评分" value={formattedScore} subtitle={`风险等级: ${riskLevel}`} />
          <SummaryItem label="贷款机构总数" value={`${loanInstitutions}`} subtitle="所有借贷机构" />
          <SummaryItem label="是否存在逾期" value={hasOverdue ? '是' : '否'} subtitle="未结清逾期状态" />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
